export default {
  login: {
    title: 'Fabrikkan',
    tableNumber: 'Choose the table number you\'re serving',
    pin: 'Enter the pin to get started',
  },
  language: {
    is: 'ÍSL',
    en: 'ENG',
  },
  layout: {
    table: 'Table',
    number: 'nr.',
    continue: 'Continue',
    waiter: 'Waiter',
    back: 'Go back',
    menu: 'Menu',
    logout: 'Go back to home screen',
    summary: {
      home: {
        dialog: {
          title: 'Home',
          message: 'Back to the menu?',
          ok: 'Yes',
          cancel: 'No',
        },
      },
    },
    dialog: {
      title: 'Help',
      message: 'Call a waiter?',
    },
  },
  customer: {
    or: 'or',
    menu: {
      title: 'Do you want to',
      order: 'Order from',
      menu: 'the menu',
      button: 'Look at menu',
    },
    waiter: {
      subTitle: 'Talk to a',
      title: 'waiter',
      button: 'Wait for waiter',
      dialog: {
        title: 'Confirmation',
        message: 'Do you want to order from a waiter?',
        ok: 'Yes',
        cancel: 'No',
      },
    },
  },
  waiter: {
    title: 'The waiter will be with you shortly',
    dialog: {
      title: 'Confirmation',
      message: 'Do you want help from a waiter?',
    },
  },
  navigation: {
    back: 'Back',
  },
  menu: {
    title: 'Menu',
  },
  category: {
    dialog: {
      title: 'Alcohol is only for age 20+',
      message: 'Please confirm you have reached that age. We reserve the right to ask for identification',
      ok: 'Yes',
      cancel: 'No',
    },
  },
  product: {
    includeEverything: 'You want to include everything?',
    change: 'Enlarge and modify',
    fries: 'The fries are better with a side sauce',
    bread: 'Change the bread?',
    added: 'got added to the order',
    dialog: {
      title: 'Warning',
      message: 'Is everything correct?',
    },
  },
  footer: {
    addProduct: 'Add to order',
    updateProduct: 'Update in order',
    confirmOrder: 'Confirm order',
    viewOrder: 'View',
  },
  order: {
    title: 'Your order',
    editProduct: 'Change',
    removeProduct: 'Remove',
    total: 'Total',
    dialogs: {
      sendOrder: {
        title: 'Confirm order',
        message: 'Is everything correct?',
        ok: 'Yes',
        cancel: 'No',
      },
      removeProduct: {
        title: 'Remove product from order?',
        message: 'Are you sure you want to remove "{product}" from the order?',
        ok: 'Yes',
        cancel: 'No',
      },
    },
  },
  orderSummary: {
    title: 'Thank you for your order',
    order: 'Your order',
    arriving: 'The food will be ready shortly!',
    orderPlaced: 'Order sent at',
  },
  notify: {
    addedToOrder: 'Added to order',
    updatedInOrder: 'Product updated',
    waiterInOrder: 'A waiter will be with you shortly',
  },
  api: {
    error: {
      dialog: {
        ok: 'Close',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Wrong pin number',
        message: 'Try again.',
      },
      pilotErrorOrderNotSaved: {
        title: 'Could not save order',
        message: 'Please contact the next staff member. Error saving order: {error}',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Could not save order',
        message: '{error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorNoData: {
        title: 'Gögn vantar',
        message: 'Pöntun var ekki vistuð. Gögn voru ekki rétt formuð: {error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Staðfestingarkóði rangur',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorCouponExpired: {
        title: 'Afsláttarkóði útrunninn',
        message: 'Kóðinn sem þú gafst upp er ekki virkur.',
      },
      pilotErrorCouponNotFound: {
        title: 'Afsláttarkóði finnst ekki',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Kortanúmer ógilt',
        message: 'Athugaðu hvort þú hafir gefið upp rétt númer.',
      },
      pilotErrorExpiredCard: {
        title: 'Gildistími korts er útrunninn',
        message: 'Prófaðu annað kort eða annan greiðslumáta.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Villa í kortanúmeri',
        message: 'Kortanúmer verður að vera 11 til 19 tölustafir',
      },
      pilotErrorOrderNotValid: {
        title: 'Engin pöntun fannst',
        message: 'Það getur gerst ef vöruúrval breytist.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'Við getum ekki afgreitt "{product}"',
        message: 'Þú verður að velja annan afhendingarmáta.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Lágmarksupphæð ekki náð',
        message: 'Til að geta valið þennan afhendingarmáta þarf að panta meira.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er ekki í boði fyrir þennan afhendingarmöguleika.',
      },
      couponNeedsDesktop: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður á vefnum.',
      },
      couponNeedsCordova: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður í appi.',
      },
      notAllowed: {
        title: 'Aðgerð ekki framkvæmd',
        message: 'Notandi hefur ekki tilskilin leyfi.',
      },
      ECONNABORTED: {
        title: 'Samskipti runnu út á tíma',
        message: 'Keyrsla tók óeðlilega langan tíma.',
      },
    },
  },
};
